import type { ReactNode, VoidFunctionComponent } from 'react';

type Props = {
  headerSlot: ReactNode;
  contentSlot: ReactNode;
  contentRightSlot: ReactNode;
};

/**
 * A foundational layout for displaying issue content with designated slots for the header, main content, and side content.
 */
const BaseIssueItemContent: VoidFunctionComponent<Props> = ({ headerSlot, contentSlot, contentRightSlot }: Props) => {
  return (
    <div className="issue-item__content">
      <div className="issue-item__content__header">{headerSlot}</div>
      <div className="issue-item__content__detail__container">
        <div className="issue-item__content__detail">{contentSlot}</div>
        <div className="issue-item__content__detail__right">{contentRightSlot}</div>
      </div>
    </div>
  );
};

export default BaseIssueItemContent;
